import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=62daa448&scoped=true"
import script from "./ColumnChart.js?vue&type=script&lang=js&external"
export * from "./ColumnChart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62daa448",
  null
  
)

export default component.exports